<div class="flex-layout center-content">
  <div class="ops-header item-grow">
    <div style="display: flex; justify-content: space-between;">
      <a routerLink="/operational-dashboard/errors-by-ship-date">Errors By Ship Date</a>

      @if (!isLoading && !didError) {
        <div class="tree-buttons">
          <button mat-raised-button color="secondary" (click)="collapseAll()">
            <mat-icon>unfold_less</mat-icon>
            <span>Collapse Tree</span>
          </button>
          <button mat-raised-button color="secondary" (click)="expandAll()">
            <mat-icon>unfold_more</mat-icon>
            <span>Expand Tree</span>
          </button>
        </div>
      }
    </div>

    <div class="filter-box">
      <insight-filters [layoutDirection]="'row'"
        [filtersSubject]="filtersSubject"
        [showMinShipFilter]="false"
        [showMaxShipFilter]="false"
        [showCheckboxFilters]="false"
        [shouldSetUrlPrams]="false">
      </insight-filters>
    </div>
  </div>
</div>

@if (isLoading) {
  <insight-loading-spinner [loadingMessage]="'Loading...'">
  </insight-loading-spinner>
}

@if (!isLoading && !didError) {
  <div class="content-box-content" style="padding: 1rem;">
    @if (!hasData()) {
      <div class="item-grow">No Error data to show</div>
    }
    <mat-tree #tree [dataSource]="nodeDataSource" [childrenAccessor]="childrenAccessor" class="tree item-grow">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node">
        <li class="mat-tree-node">
          <!-- use a disabled button to provide padding for tree leaf -->
          <button mat-icon-button disabled></button>
          <a class="node-name" [routerLink]="['/']" [queryParams]="node.queryParams">
            {{node.name}} ({{node.nodeMatchesCount}})
          </a>
        </li>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node;when: hasChild" [isExpandable]="true">
        <li>
          <div class="mat-tree-node">
            <button mat-icon-button matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
                {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
            <a class="node-name" [routerLink]="['/']" [queryParams]="node.queryParams">
              {{node.name}} ({{node.nodeMatchesCount}})
            </a>
          </div>
          <ul [class.tree-invisible]="!tree.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
}

@if (!isLoading && didError) {
  <div class="flex-layout center-content">
    <div>
      An error occurred while getting orders by shipment.
    </div>
  </div>
}
